import { render, staticRenderFns } from "./Participante.vue?vue&type=template&id=dab5defa"
import script from "./Participante.vue?vue&type=script&lang=js"
export * from "./Participante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports